import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

export default class Head extends Component {
  @service head;

  <template>
    <title>{{this.head.title}}</title>
    <meta name="description" content={{this.head.description}} />

    <meta property="og:title" content={{this.head.ogTitle}} />
    <meta property="og:description" content={{this.head.ogDescription}} />
    <meta property="og:image" content={{this.head.ogImage}} />
    <meta property="og:type" content={{this.head.ogType}} />

    <meta name="twitter:card" content={{this.head.twitterCard}} />
    <meta name="twitter:site" content={{this.head.twitterSite}} />
    <meta name="twitter:title" content={{this.head.ogTitle}} />
    <meta name="twitter:description" content={{this.head.ogDescription}} />
    <meta name="twitter:image" content={{this.head.ogImage}} />

    {{#if this.head.canonical}}
      <link rel="canonical" href={{this.head.canonical}} />
    {{/if}}

    {{#if this.head.robots}}
      <meta name="robots" content={{this.head.robots}} />
    {{/if}}
  </template>
}
